import React, {useRef, useState} from "react";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {FileUploader, FileUploaderRef} from "./FileUploader";
import {easasErrorAlert} from "../../fragments/easas-global-fragment/EasasGlobalAlerts";
import {Chips} from "primereact/chips";

interface FileDialogProps {
    isPublic: boolean;
    visible: boolean;
    setVisible: (v: boolean) => void;
}

export default function FileDialog(props: FileDialogProps){
    const uploadRef = useRef<FileUploaderRef>() as React.MutableRefObject<FileUploaderRef>;

    const [fileTags, setFileTags] = useState<string[]>([]);
    const [desc, setDesc] = useState<string>()

    const [locked, setLocked] = useState(false)

    const upload = () => {
        console.warn("upload", desc, fileTags)

        // validate tags, no non non-alphanumeric characters
        for (let tag of fileTags) {
            if(!tag.match(/^[a-zA-Z0-9 ]+$/)) {
                easasErrorAlert("Tags can only contain letters and numbers")
                return;
            }
        }

        setLocked(true)
        uploadRef.current!!.upload();
    }

    const onUploaded = () => {
        setFileTags([])
        setDesc("")
        props.setVisible(false);
        setLocked(false)
    }

    const onErrored = () => {
        setLocked(false)
    }

    const header = props.isPublic ? "Public file upload" : "Company file upload"


    return <Dialog header={header} visible={props.visible} style={{width: '50vw'}} modal onHide={() => {
        props.setVisible(false)
    }}>
        <div className="p-fluid p-formgrid p-grid">
            {/* ===== Table selection ======= */}
            <div className="p-field p-col-12">
                <label>File</label>
                <FileUploader ref={uploadRef}
                              isPublic={props.isPublic}
                              desc={desc}
                              fileTags={fileTags}
                              onUploaded={onUploaded}
                              onErrored={onErrored}
                />
            </div>

            <div className="p-field p-col-12">
                <label>Description</label>
                <InputText value={desc} onChange={e => setDesc(e.target.value)}/>
            </div>

            <div className="p-field p-col-12">
                <label>Tags</label>
                <Chips value={fileTags} onChange={(e) => setFileTags(e.value)}/>
            </div>

            <Button label="Upload" icon="pi pi-upload" onClick={upload} disabled={locked}></Button>
        </div>
    </Dialog>
}